import { ArrowRight, User } from "lucide-react";
import { formatChf } from "@/lib/data";
import { useLang } from "@/lib/i18n";

export default function VehicleActionPanel({ vehicle, price, unitsCount = 0, lines = [], bookingFor, onBookingFor, onContinue }) {
  const { t } = useLang();
  const i18nVeh = t(`veh.${vehicle.id}`);
  const multi = unitsCount > 1;

  return (
    <div className="mt-5 hidden rounded-[1.5rem] border border-ink/10 bg-white p-5 shadow-[0_24px_70px_-46px_rgba(16,24,40,0.35)] lg:block" data-testid="vehicle-action-panel">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-base font-semibold text-ink">{multi ? `${unitsCount} ${t("bk.vehicles_word")}` : i18nVeh.name}</p>
          <p className="mt-1 text-xs text-slate" data-testid="vehicle-panel-lines">{multi ? lines.join(" · ") : i18nVeh.model}</p>
        </div>
        <p className="text-xl font-semibold tracking-tight text-ink" data-testid="vehicle-panel-price">{formatChf(price)}</p>
      </div>
      <div className="mt-5 grid gap-2">
        {[
          ["self", t("bk.for_me")],
          ["guest", t("bk.for_guest")],
        ].map(([id, label]) => (
          <button key={id} type="button" onClick={() => onBookingFor(id)} data-testid={`passenger-toggle-${id === "self" ? "me" : "guest"}`}
            className={`flex items-center gap-3 rounded-2xl border px-4 py-3 text-left text-sm font-medium transition-colors ${
              bookingFor === id ? "border-miles bg-miles-ice/60 text-ink" : "border-ink/10 text-slate hover:border-miles/30 hover:text-ink"
            }`}>
            <span className={`flex h-8 w-8 items-center justify-center rounded-full ${bookingFor === id ? "bg-miles text-white" : "bg-cloud text-slate"}`}>
              <User className="h-4 w-4" strokeWidth={1.5} />
            </span>
            {label}
          </button>
        ))}
      </div>
      <button type="button" onClick={onContinue} data-testid="booking-next-button"
        className="mt-5 flex h-[52px] w-full items-center justify-center gap-2 rounded-full bg-miles text-sm font-semibold text-white shadow-[0_14px_34px_rgba(36,87,255,0.24)] transition-[background-color,transform] hover:-translate-y-0.5 hover:bg-miles-dark">
        {t("bk.cta_traveler")} <ArrowRight className="h-4 w-4" strokeWidth={1.5} />
      </button>
    </div>
  );
}
